<template>
    <div>
        <l-card-headline>
            <template v-if="isVisitor">
                {{ $t("profile.feedback.titleVisitor", { firstname: user.firstname }) }}
            </template>
            <template v-else>
                {{ $t("profile.feedback.title") }}
            </template>
        </l-card-headline>

        <div class="tw-pt-6">
            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!hasResults" class="tw-text-gray-400">
                {{ $t("profile.feedback.empty") }}
            </div>

            <l-instant-feedback-list
                v-else
                :feedback-entries="instantFeedbackListByUser[user._id]"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardHeadline from "@/components/LCardHeadline";
import LSkeletonLoader from "@/components/LSkeletonLoader";
import LInstantFeedbackList from "@/components/LUserProfile/LInstantFeedbackList";

export default {
    components: {
        LCardHeadline,
        LSkeletonLoader,
        LInstantFeedbackList,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
        isVisitor: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        ...mapGetters({
            instantFeedbackListByUser: "feedback/feedback/listByUser",
        }),
        hasResults() {
            return (
                Array.isArray(this.instantFeedbackListByUser?.[this.user._id]) &&
                this.instantFeedbackListByUser[this.user._id].length
            );
        },
    },
    async mounted() {
        try {
            await this.$store.dispatch("feedback/feedback/getListByUser", {
                payload: { userId: this.user._id },
            });
        } finally {
            this.isLoading = false;
        }
    },
    methods: {},
};
</script>
